// import '@capacitor-community/http';
import { IonAlert, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonPage, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToast, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { empresaConfiguracoesAlterar, empresaConfiguracoesCarregar, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './ConfiguracaoMesas.css';

type Props = {
  abrirMenu: boolean;
};

const ConfiguracaoMesas: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const [showToast2, setShowToast2] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [showLoading, setShowLoading] = useState(true);
  const [showSucesso, setShowSucesso] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [taxaServico, setTaxaServico] = useState('');
  const [senhaMesa, setSenhaMesa] = useState('');
  const [nomeInternoMesaOuComanda, setNomeInternoMesaOuComanda] = useState('');
  const [nomeInternoMesasOuComandas, setNomeInternoMesasOuComandas] = useState('');
  const [tipoSelecionado, setTipoSelecionado] = useState("");


  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConta();
  });

  function carregarConta() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(empresaConfiguracoesCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaConfiguracoesCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        async (response: any) => {
          console.log(response);

          setTaxaServico(response.Item.taxaServico || '');

          const chaveSecreta = 'b5f2bc02-83ab-4c02-b11d-462771eaa7fa';

          if (response?.Item?.senhaMesa) {
            try {
              const senhaDescriptografada = await decryptSenhaAES(response.Item.senhaMesa, chaveSecreta);
              setSenhaMesa(senhaDescriptografada || '');
            } catch (error) {
              console.error('Erro ao descriptografar senhaMesa:', error);
              setSenhaMesa(''); // ou algum valor padrão
            }
          } else {
            // Caso não tenha valor, seta vazio ou valor padrão
            setSenhaMesa('');
          }


          const nomeSingular = response.Item.nomeInternoMesaOuComanda || "";
          const nomePlural = response.Item.nomeInternoMesasOuComandas || "";

          setNomeInternoMesaOuComanda(nomeSingular);
          setNomeInternoMesasOuComandas(nomePlural);

          if (nomeSingular.toLowerCase() === "mesa" && nomePlural.toLowerCase() === "mesas") {
            setTipoSelecionado("mesas");
          } else if (nomeSingular.toLowerCase() === "comanda" && nomePlural.toLowerCase() === "comandas") {
            setTipoSelecionado("comandas");
          } else {
            setTipoSelecionado(""); // caso não bata com nenhum padrão
          }

          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }


  const cadastrar = () => {
    setShowToast2(true);
  }

  const onChangeTaxaServico = (e: any) => {
    e.preventDefault();

    let v = e.target.value;

    // Remove tudo que não for número
    v = v.replace(/\D/g, '');

    // Remove zeros à esquerda desnecessários
    v = v.replace(/^0+/, '');

    // Atualiza o estado com o valor tratado como inteiro
    setTaxaServico(v);
  };

  async function criptografarSenhaAES(senha: string, chave: string): Promise<string> {
    const encoder = new TextEncoder();

    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(chave),
      { name: "PBKDF2" },
      false,
      ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: encoder.encode("algum-sal-fixo"),
        iterations: 100000,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["encrypt"]
    );

    const iv = crypto.getRandomValues(new Uint8Array(12)); // IV 12 bytes
    const encrypted = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      encoder.encode(senha)
    );

    const encryptedBytes = new Uint8Array(encrypted);
    const combined = new Uint8Array(iv.length + encryptedBytes.length);

    for (let i = 0; i < iv.length; i++) combined[i] = iv[i];
    for (let i = 0; i < encryptedBytes.length; i++) combined[iv.length + i] = encryptedBytes[i];

    let binaryString = "";
    for (let i = 0; i < combined.length; i++) {
      binaryString += String.fromCharCode(combined[i]);
    }

    return btoa(binaryString);
  }

  async function decryptSenhaAES(encryptedBase64: string, chave: string): Promise<string> {
    const encoder = new TextEncoder();
    const decoder = new TextDecoder();

    const encryptedBinaryString = atob(encryptedBase64);
    const encryptedData = new Uint8Array(encryptedBinaryString.length);
    for (let i = 0; i < encryptedBinaryString.length; i++) {
      encryptedData[i] = encryptedBinaryString.charCodeAt(i);
    }

    if (encryptedData.length < 13) {
      throw new Error("Dados muito pequenos para conter IV + ciphertext");
    }

    const iv = encryptedData.slice(0, 12);
    const encryptedBytes = encryptedData.slice(12);

    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(chave),
      { name: "PBKDF2" },
      false,
      ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: encoder.encode("algum-sal-fixo"),
        iterations: 100000,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["decrypt"]
    );

    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      encryptedBytes
    );

    return decoder.decode(decrypted);
  }

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">


          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>


          <IonTitle slot="start">Configurações de {(window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>



          {/* <IonItem lines="full">
            <IonLabel color="primary">{(window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas")}</IonLabel>
          </IonItem> */}


          <IonItem lines="none">

            <IonLabel position="stacked">Taxa de serviço (%)</IonLabel>
            <IonTextarea
              style={{ "--background": "#eeeeee", "borderRadius": "5px", "padding": "10px" }}
              rows={1}
              value={taxaServico}
              maxlength={50}
              placeholder="% - Taxa de Serviço"
              onIonChange={(e: any) => onChangeTaxaServico(e)}
            ></IonTextarea>

          </IonItem>

          <IonItem lines="none">

            <IonLabel position="stacked">Senha transferir/alterar</IonLabel>
            <IonTextarea
              style={{ "--background": "#eeeeee", "borderRadius": "5px", "padding": "10px" }}
              rows={1}
              value={senhaMesa}
              maxlength={20}
              placeholder="Digite a senha"
              onIonChange={(e: any) => setSenhaMesa(e.detail.value!)}
            ></IonTextarea>

          </IonItem>

          <IonItem lines="none">
            <IonLabel position="stacked">Opções</IonLabel>
            <IonSelect
              value={tipoSelecionado}
              onIonChange={(e) => {
                const valor = e.detail.value;
                setTipoSelecionado(valor);
                if (valor === "mesas") {
                  setNomeInternoMesaOuComanda("Mesa");
                  setNomeInternoMesasOuComandas("Mesas");
                } else if (valor === "comandas") {
                  setNomeInternoMesaOuComanda("Comanda");
                  setNomeInternoMesasOuComandas("Comandas");
                }
              }}
            >
              <IonSelectOption key="mesas" value="mesas">
                Mesas
              </IonSelectOption>
              <IonSelectOption key="comandas" value="comandas">
                Comandas
              </IonSelectOption>

            </IonSelect>
          </IonItem>

        </IonList>
        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonAlert isOpen={showToast2}
          onDidDismiss={() => setShowToast2(false)}
          header={'Alterar configurações'}
          message={'Você <strong>confirma</strong> a alteração?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: async () => {

                setShowLoading(true);

                window.localStorage.setItem("nomeInternoMesaOuComanda", nomeInternoMesaOuComanda);
                window.localStorage.setItem("nomeInternoMesasOuComandas", nomeInternoMesasOuComandas);

                const chaveSecreta = 'b5f2bc02-83ab-4c02-b11d-462771eaa7fa';

                const senhaCriptografada = senhaMesa ? await criptografarSenhaAES(senhaMesa, chaveSecreta) : '';

                const objectRequest = {
                  taxaServico,
                  senhaMesa: senhaCriptografada,
                  nomeInternoMesaOuComanda,
                  nomeInternoMesasOuComandas,
                };

                let id = loja;

                console.log("id", id)

                requestService(
                  empresaConfiguracoesAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?tipo=mesas"),
                  {
                    method: empresaConfiguracoesAlterar.method,
                    body: JSON.stringify(objectRequest),
                    headers: [
                      ["token", window.localStorage.getItem("token")]
                    ],
                    credentials: 'include'
                  },
                  history,
                  (response: any) => {
                    console.log(response);
                    if (response) {
                      setTextToast("Alteração realizado com sucesso.");
                      setShowSucesso(true);

                    } else if (response.status === 400) {
                      console.log(response);
                      setTextToast("Ocorreu um erro ao efetuar a alteração.");
                      setShowToast(true);

                    }
                    setShowLoading(false);
                  },
                  (error: any) => {
                    console.log(error);
                    setTextToast("Ocorreu um erro ao efetuar a alteração.");
                    setShowToast(true);
                    setShowLoading(false);
                  })
              }
            }
          ]}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showSucesso}
          onDidDismiss={(e: any) => { setShowSucesso(false); history.goBack(); }}
          message={'Alterações salvas com sucesso!'}
          duration={3000}
          animated={false}
        />
      </IonContent >
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton onClick={() => cadastrar()} expand="block" type="submit" hidden={acessos?.configuracoes != 'edicao'}>Salvar</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage >
  );
};

export default ConfiguracaoMesas;
